class EventTypes {
    static DOMContentLoaded: string = "DOMContentLoaded";
    static click: string = "click";
    static change: string = "change";
}
export {  EventTypes }
